<template>
  <div class="container-fluid container-main">
    <div class="row" style="height: 100%;">
      <div class="col-4" style="height: 100%;">
        <b-d-t-n-s-bug-view v-on:error-changed="onErrorChanged"></b-d-t-n-s-bug-view>
      </div>
      <div class="col-8" style="height: 100%; overflow: auto">
        <div class="row">
          <div class="col">
            <b-d-t-n-s-view v-bind:bdtns_no="bdtns_no" v-bind:highlights="lines"></b-d-t-n-s-view>
          </div>
          <div class="col">
            <c-d-l-i-view v-bind:cdli_no="cdli_no"></c-d-l-i-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BDTNSBugView from '@/components/BDTNSBugView'
import CDLIView from '@/components/CDLIView'
import BDTNSView from '@/components/BDTNSView'

export default {
  name: 'BDTNSDebugger',

  components: {
    BDTNSBugView,
    CDLIView,
    BDTNSView
  },

  data () {
    return {
      cdli_no: '',
      bdtns_no: '',
      lines: ['1']
    }
  },

  methods: {
    onErrorChanged: function(event) {
      this.bdtns_no = event.bdtns_no;
      this.lines = [event.line_no];
    }
  },

  watch: {
      bdtns_no: function (val) {
        axios.post("http://localhost:8081/cdlino", { bdtns_no: val })
          .then(response => {
            this.cdli_no = response.data;
          })
          .catch(e => {console.log(e)})
      }
  },

  mounted () {
    this.bdtns_no = '002200'
  }
}
</script>

<style>
div.container-main {
  height: 100vh;
  width: 100vw;
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/BDTNSDebugger.vue